module.exports = __webpack_public_path__ + "static/media/Services-06.79ef2de6.jpg";